<template>
  <v-text-field
    :value="value"
    :label="label"
    :prepend-icon="icon"
    :disabled="disabled"
    @input="onInput"
  ></v-text-field>
</template>

<script>
  export default {
    name: 'Search',
    props: {
      value: String,
      icon: {
        type: String,
        default: 'search',
      },
      delay: {
        type: Number,
        default: 0,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      label: String,
    },
    data() {
      return {
        timeout: null,
      };
    },
    methods: {
      onInput(value) {
        if (this.delay) {
          if (this.timeout) {
            window.clearTimeout(this.timeout);
            this.timeout = null;
          }
          this.timeout = window.setTimeout(() => {
            this.$emit('input', value);
          }, this.delay);
        } else {
          this.$emit('input', value);
        }
      },
    },
  };
</script>

<style scoped>

</style>
